module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/btn_on_sp-3cc3a1edd628730643e1ee40b7cd760d.jpg";